const generateID = (storage = false, key = 'wizardID') => {
    let ID = Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1) +
        Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1) +
        Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);

    ID = ID.toUpperCase();

    if (storage)
        localStorage.setItem(key, ID);

    return ID;
}

export { generateID };
